// removed by extract-text-webpack-plugin
module.exports = {"container":"paAijO1dB_0h3NIN_FQwi","Icon":"_2ZFF3lVPOKuGsrwTFZPHQw","Title":"_3Y8Qlp8BSlxTn4cmN_aL3N","Email":"BQvUA0Kl7a7378qWLEG0V","Signer":"_1TbyaOdPvTQGCds9FyhmkD"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/DocumentVerify/Main/Verify/Viewers/styles.css
// module id = 3009
// module chunks = 0